<div class="imageViewWrapper"
    style="height: 100%; margin: 0px; display: flex; flex-direction: column; align-items: center;">
    <div class="innerImageView" style="height: 80%; margin-bottom: 5px;">
        <ng-container *ngIf="imgPath">
            <ng-container *ngIf="isVideo(imgPath); else imageTemplate">
                <video #videoPlayer style="height: 100%; width: 100%;" controls>
                    <source [src]="imgPath" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            </ng-container>
            <ng-template #imageTemplate>
                <img [src]="imgPath" alt="" style="height: 100%; margin-bottom: 5px;" />
            </ng-template>
        </ng-container>
    </div>

    <div class="imageThumbView" style="width: 100%; overflow-x: auto; display: flex; justify-content: center;">
        <ng-container *ngFor="let thumb of ImageList">
            <ng-container *ngIf="isVideo(thumb); else imageThumbTemplate">
                <video #videoThumbPlayer (click)="ViewImage(thumb)" style="width: 80px; margin-right: 5px;">
                    <source [src]="thumb" type="video/mp4">
                </video>
            </ng-container>
            <ng-template #imageThumbTemplate>
                <img [src]="thumb" alt="" (click)="ViewImage(thumb)" style="height: 50px; margin-right: 5px;" />
            </ng-template>
        </ng-container>
    </div>
</div>